import React from "react";
import Markdown from "markdown-to-jsx";
import styled from "styled-components/macro";
import { DisclaimerText } from "../ChatBot/ChatBot";
import { SendMessage, SendMessageProps } from "./SendMessage";

const Disclaimer = styled(DisclaimerText)`
  margin-top: ${({ theme }) => theme.resolve("spacing_md")};
  font-size: ${({ theme }) => theme.resolve("font_size_xs")};
  color: ${({ theme }) => theme.secondaryTextColor};
`;

export function SearchComposer({
  disclaimer,
  ...props
}: SendMessageProps & {
  disclaimer?: string;
}) {
  return (
    <>
      <SendMessage {...props} />
      {disclaimer && (
        <Disclaimer as="aside" aria-label="Assistant disclaimer">
          <Markdown>{disclaimer}</Markdown>
        </Disclaimer>
      )}
    </>
  );
}
